import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  ManageDomesComponent,
  LayoutWrapperMain, Page,
} from '../../components';
import config from '../../config';
import './AddDomes.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const ManageDomesPageComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'Domesmanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <ManageDomesComponent />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
  // submitSignup: (dispatch: any, data: any) => dispatch(Signup(data)),
});

const ManageDomes = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ManageDomesPageComponent);

export default ManageDomes;
